"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLocalStorageItem = exports.useLocalStorage = void 0;
const react_1 = __importDefault(require("react"));
const contexts_1 = require("../contexts");
/**
 * Will return a wrapper object with localStorage
 *
 * @example
 *
 * ```ts
 * import { useLocalStorage } from '@mulesoft/exchange-react-hooks';
 *
 * const MyComponent = ({ ...props }) => {
 *   const { setItem, getItem } = useLocalStorage();
 *   setItem('key','value');
 *   const value getItem('key');
 *   ...
 * };
 * ```
 *
 * @returns An object to interact with the local storage
 */
function useLocalStorage() {
    return react_1.default.useContext(contexts_1.LocalStorageContext);
}
exports.useLocalStorage = useLocalStorage;
/**
 * Will return a values as useValue
 *
 * @example
 *
 * ```ts
 * import { useLocalStorageItem } from '@mulesoft/exchange-react-hooks';
 *
 * const MyComponent = ({ ...props }) => {
 *   const [ value, setItem ] = useLocalStorageItem('groupId:assetId');
 *   setItem('newValue');
 *   ...
 * };
 * ```
 *
 * @param key The object key to get the value from
 * @returns The value for the key
 */
function useLocalStorageItem(key) {
    const { getItem, setItem } = useLocalStorage();
    return [getItem(key), (value) => setItem(key, value)];
}
exports.useLocalStorageItem = useLocalStorageItem;
